import enLang from './entries/en-US';
import zhHantLang from './entries/zh-Hant-HK';

const AppLocale = {
  en: enLang,
  'zh-Hant': zhHantLang,
};

export default AppLocale;
